<template>
	<div class="popup_wrpr product-settings-popup-wrap active">
		<div class="app_settings_popup" :class="{right_open: showRightPanel}">
			<div class="popup_left_side">

				<Loading v-show="loading"/>

				<a href="#" class="close_popup_btn" @click.prevent="closePopup">
					<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
				</a>

				<div class="popup_side_content scroll" v-if="newData" :class="{'not-valid': validationError}">
					<h3 class="popup_title product-name layout-row" style="  border-bottom: 1px solid #e5e6f1;">
                      <span class="flex">
                        {{ newData.name || '' }}
                      </span>
<!--						<div class="flex-none info_btn" @click="showRightPanel = !showRightPanel">-->
<!--							<span>Help</span>-->
<!--							<inline-svg :src="require('@/assets/img/info_icon.svg')"/>-->
<!--						</div>-->
					</h3>
					<!-- Basic -->
					<div class="brdr_content_wrpr">
						<h3 class="brdr_content_title">Basic</h3>
						<input-field required label="Product name" v-model="newData.name"/>
						<v-switch label="Is this an order bump?" v-model="newData.is_ob" :value="newData.is_ob"/>
					</div>

						<div class="expandable-area" :class="{closed:status.priceClosed}">
							<h3 class="expandable-title" @click="statusToggle('priceClosed')">Price
								<inline-svg class="arrow" :src="require('@/assets/img/chevron-top.svg')" />
							</h3>

						<div class="area-content">
						<v-switch label="Is a subscription?" v-model="newData.is_subscription"
						          :value="newData.is_subscription"/>

						<div class="mb-15" style="margin-top: 25px;" v-if="!newData.is_subscription">
							<price-field :currency-code="currencyCode" label="Price" required
							             v-model.number="newData.price"/>
						</div>

						<div class="billing-panel margin-t-25" v-if="newData.is_subscription">
							<price-field small class="billing-box" :currency-code="currencyCode"
							             label="Billing amount" required v-model.number="newData.billing_amount"/>

							<select-field small class="billing-box" caption="Recurring times" label="text"
							              @change="selectNumber($event, 'billing_recurring_times')"
							              v-model="newData.billing_recurring_times" :options="recurringTimes" />

							<select-field small class="billing-box __cycle" caption="Billing cycle" label="text"
							              @change="selectNumber($event, 'billing_cycle')"
							              v-model="newData.billing_cycle" :options="billingCycles" />

							<select-field small class="billing-box __cycle" caption="Cycle type" label="text"
							              @change="selectNumber($event, 'cycle_type')"
							              v-model="newData.cycle_type" :options="cycleTypes" />
						</div>

						<div class="p-0 b-0 " v-if="newData.is_subscription">
							<v-switch class="margin-b-20" label="Has a trial period?" v-model="newData.has_trial"
							          :value="newData.has_trial"></v-switch>
						</div>

						<div class="billing-panel" v-if="newData.has_trial && newData.is_subscription">

							<price-field small class="billing-box" :currency-code="currencyCode"
							             label="Billing amount" required v-model.number="newData.trial_billing_amount"
							             @change="editNumber($event, 'trial_billing_amount')" />

							<select-field small class="billing-box" caption="Billing cycle" label="text"
							              @change="selectNumber($event, 'trial_billing_cycle')"
							              v-model="newData.trial_billing_cycle" :options="billingCycles" />

							<select-field small class="billing-box" caption="Cycle type" label="text"
							              @change="selectNumber($event, 'trial_cycle_type')"
							              v-model="newData.trial_cycle_type" :options="cycleTypes" />
						</div>

							<div class="margin-t-25" style="margin-bottom: 5px">
								<span class="layout-row"><b>Displayed price</b> &nbsp;(optional)
									<info-icon>
										<p>
										This will be the price "text" that will be shown to your customers on your funnel.
									</p>
									<div class="info-message">
										You can use dynamic texts such as: <b>{PRICE}</b>, <b>{CURRENCY}</b> and <b>{TRIAL-PRICE}</b>.
									</div>
									</info-icon>
								</span>
							</div>
							<quill-editor class="display-price-editor ql-snow"
							              :class="{'__focused':priceEditorFocused}"
							              @ready="onQuillEditorCreated"
							              @focus="priceEditorFocused=true"
							              :content="newData.display_price || ''"
							              @change="onEditorChange"
							              :options="editorOption">
							</quill-editor>
						</div>
					</div> <!-- Price -->

					<product-image-panel :product="newData"/>

					<!--	                Settings -->
					<div class="expandable-area" :class="{closed:status.highlightClosed}" v-if="!newData.is_ob">
						<h3 class="expandable-title" @click="statusToggle('highlightClosed')">Settings
							<inline-svg class="arrow" :src="require('@/assets/img/chevron-top.svg')" />
						</h3>
						<div class="area-content">

							<v-switch v-model="config.default" :value="config.default"
							          label="Select by default" />
							<v-switch v-model="config.hidden" :value="config.hidden"
							          label="Hide from products list"
							          info="When selected the product will not be visible to customers in product lists.
							          Customers can still be charged for it if selected by default." />

							<template v-if="!config.hidden">
								<v-switch v-model="config.super_highlight" :value="config.super_highlight"
								          label="Highlight" />

								<!-- top tag and side tag -->
								<div class="layout-row flex margin-t-25" >
										<input-field class="flex" label="Top tag (Optional)" placeholder="BEST SELLING 🔥" v-model="config.top_tag">
											<template v-slot:info>
												<p><b>Top tag</b></p>
												<p>This is the <b>Top</b> tag shown on your highlighted products, can be slightly longer than a side
													tag, <i>such as:</i> BEST SELLING...etc</p>
											</template>
										</input-field>
									<div style="width: 30px"></div>
										<input-field class="flex" label="Side tag (Optional)" placeholder="NEW" v-model="config.tag">
											<template v-slot:info>
												<p><b>Side tag</b></p>
												<p>This is the <b>side</b> tag shown on your highlighted products, usually a short word, <i>such
													as:</i> TOP, BEST, NEW...etc</p>
											</template>
										</input-field>
								</div>
								<div class="form-group inline mb-24 margin-t-15" >
									<div class="color-control">
										<span class="label">Color:</span>
										<v-swatches
												v-model="config.color"
												show-fallback
												shapes="circles"
												popover-x="right"
												fallback-ok-text="Set color"
												:swatches="swatches"
												:wrapper-style="{width: '145px', paddingLeft: '0'}"
												:swatch-style="{width: '25px', height: '25px', borderStyle: 'solid', borderColor: '#FFFFFF', borderWidth: '2px', marginRight: '5px', marginLeft: '5px'}"
										></v-swatches>
									</div>
									<div class="font-options">
										<span class="label">Text Size:</span>
										<label class="radio">
											<input type="radio" name="font" value="small" v-model="config.size">
											<span class="radiomark"></span>
											Small
										</label>
										<label class="radio">
											<input type="radio" name="font" value="big" v-model="config.size">
											<span class="radiomark"></span>
											Big
										</label>
									</div>
								</div>
							</template>
						</div>
					</div>

					<!--	         Variants OB  -->
					<div class="brdr_content_wrpr" v-if="newData.is_ob">
						<h3 class="brdr_content_title">Variants</h3>
						<div class="txt-wrap">
							<p>
								Order bumps do not support having variants, If you believe this is something we
								should work on then do let us know at <a href="https://community.funnelish.com" target="_blank">Funnelish
								community</a>.
							</p>
						</div>
					</div>

					<!--	         Variants  -->
					<product-variants-panel :variants="newVariants" @openVariants="openVariants"
					                        :savingVariants="variantsSaving"
					                        :product="newData" :funnel-id="newData.funnel_id" />
					<manage-variants :product="newData" v-if="manageVariantsOpen" @close="manageVariantsOpen=false" :funnel-id="newData.funnel_id" />

					<!-- Automations -->
					<div class="expandable-area" :class="{closed:status.automationsClosed}" >
						<h3 class="expandable-title" @click="statusToggle('automationsClosed')">Automations
							<inline-svg class="arrow" :src="require('@/assets/img/chevron-top.svg')" />
						</h3>

						<div class="area-content">
							<div class="txt-wrap mb-15">
								<p>
									Trigger any action with our 3rd party integrations when the product is purchased, refunded, subscribed
									to, or canceled.
								</p>
							</div>
							<div class="automation-items entries-table" style="position: relative;"
							     v-if="newAutomations && newAutomations.length">
								<automation-entry
										v-for="item in newAutomations" :key="item.id"
										:item="item"
										:title="automationTitle(item.trigger_id)"
										@click="editAutomationItem(item)"
										@delete="itemEntryDeleteClick"
								/>

									<DeleteAutomationPopup v-if="isdeleteAutomationOpen"
									                       :is-plus="true"
									                       :automation="currentAutomation"
									                       @done="deleteAutomationItem($event.id)"
									                       @close="isdeleteAutomationOpen=false,currentAutomation=null"/>
								<v-spinner v-if="loadingAutomations"/>
							</div>

<!--							<portal to="popup" v-if="automationPopupOpen">-->
								<AutomationPopup  v-if="automationPopupOpen" :product="currentProduct"
								                 :step-id="newData.step_id" :funnel-id="newData.funnel_id"
								                 :edit="currentAutomation" :flag="currentAutomation"
								                 :is-edit="!!currentAutomation.id"
								                 :automation="currentAutomation"
								                 :productId="newData.id" :is-plus="true"
								                 @close="automationPopupOpen=false" @done="automationSaved" />
<!--							</portal>-->
							<div class="layout-row margin-t-15">
								<v-button border :locked="!is('automations')" @click="showAutomationPopup" label="Create new automation"/>
							</div>
						</div>
					</div>

				</div>

				<div class="bottom_btns_wrpr">
					<div class="left layout-row">
						<v-button label="Cancel" @click.prevent="closePopup" border/>
						<v-button label="Save changes" :locked="!is('editor')" @click.prevent="saveData" :class="{ disabled: validation.length }"/>
					</div>
					<v-button label="Delete product" :locked="!is('editor')" border red @click="deleteProduct(currentProduct.id)"/>
				</div>
			</div>
			<div class="popup_right_side">
				<div class="flex layout-column">
					<div class="alert_box orange" style="margin:auto">
						<div class="icon">
							<inline-svg :src="require('@/assets/img/warning_icon.svg')"/>
						</div>
						<span>Coming soon!</span>
					</div>
				</div>
				<!--                <product-preview v-show="showRightPanel" :products="products" :product="currentProduct"></product-preview>-->
			</div>
		</div>
	</div>
</template>

<script>
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import API from "@/api"
import Loading from "@/components/Loading.vue"
import {mapGetters} from "vuex"
import currencies from "@/helpers/currencies"
import ProductPreview from "@/views/funnels/steps/product_preview/product_preview";
import InputField from "@/components/base/input-field";
import VSwitch from "@/components/base/v-switch";
import PriceField from "@/components/base/price-field";
import VButton from "@/components/base/v-button";
import AutomationItemEntry from "@/views/funnels/steps/products/automationItemEntry";
import DeleteAutomationPopup from "@/views/funnels/steps/products/delete_automation_popup";
import AutomationPopup from "@/components/popups/automation/AutomationPopup";
import AutomationEntry from "@/views/funnels/funnel-plus/steps/products/automation-entry";
import VSpinner from "@/components/base/v-spinner";
import ProductImagePanel from "@/views/funnels/funnel-plus/steps/products/product-image-panel";
import ProductVariantsPanel from "@/views/funnels/funnel-plus/steps/products/product-variants-panel";
import ManageVariants from "@/views/funnels/funnel-plus/steps/products/manage-variants";
import QuillEditor from '@/components/base/QuillEditor';
import InfoIcon from "@/components/base/info-icon";
import {is} from "@/helpers/roles";
import SelectField from "@/components/base/select-field";

export default {
	name: "ProductSidePanel",
	props: {
		inEditor: {
			type: Boolean
		},
		product: {
		    type: Object,
		},
		delete: {
			require: true,
			type: Function
		}
	},
	components: {
		SelectField,
		InfoIcon,
		QuillEditor,
		ManageVariants,
		ProductVariantsPanel,
		ProductImagePanel,
		VSpinner,
		AutomationEntry,
		AutomationPopup,
		DeleteAutomationPopup,
		AutomationItemEntry,
		VButton,
		PriceField,
		VSwitch,
		InputField,
		ProductPreview,
		VSwatches,
		Loading
	},
	mixins: [API],
	data() {
		return {
			variantsSaving: false,
			manageVariantsOpen: false,
			status: {
				imageClosed: false,
				automationsClosed: false,
				priceClosed: false,
				variantsClosed: false,
				highlightClosed: false,
			},
			priceEditorFocused:false,
			editorOption: {
				// modules: {
				// 	// imageResize: {displaySize: true, modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]},
				// 	// history: {maxStack: 0},
				// 	// toolbar: {
				// 	// 	container: '#toolbar_' + this.id
				// 	// },
				// },
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],        // toggled buttons
						// ['blockquote'],

						[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
						// [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
						// [{ 'direction': 'rtl' }],                         // text direction

						['size', { 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

						[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
						[{ 'align': [] }],

						['clean']                                         // remove formatting button
					]
				},
				theme: 'snow'
			},
			loadingAutomations: false,
			isdeleteAutomationOpen: false,
			automationPopupOpen: false,
			validationError: false,
			newData: {
				name: ''
			},
			loading: true,
			config: {},
			color: "#FF0000",
			swatches: ['#FF0000', '#68C2E9', '#15D7AE', '#FDCC5E', '#4368E0', '#252A32', '#636A7B', '#C5C7D2', '#2E408C', '#97AACD', '#449CF4', '#6689FC'],
			newVariants: [],
			newAutomations: [],
			showRightPanel: false,
			settingsToggle: true,
			recurringTimes: [{id: 0, text: 'Infinite'}],
			billingCycles: [],
			cycleTypes: [
				{id: 1, text: "day(s)"},
				{id: 2, text: "week(s)"},
				{id: 3, text: "month(s)"},
				{id: 4, text: "year(s)"}
			],
			validation: [],
			currentProduct: {},
			currentAutomation: {},
			products: [],
		}
	},
	computed: {
		...mapGetters(["ifError", 'getFunnelStore']),
		getSymbol() {
			let target = currencies.find(item => item.id === this.currencyCode);
			if (target) {
				return target.symbol
			} else {
				return "$"
			}
		},
		stepId() {
			if (this.inEditor) return this.product.step_id;
			return parseInt(this.$route.params.step);
		},
		funnelId() {
			if (this.inEditor) return this.product.funnel_id;
			return parseInt(this.$route.params.id);
		},
		productId() {
			if (this.inEditor) return this.product.id;
			return parseInt(this.$route.params.productId);
		},
		currencyCode() {
			return this.getFunnelStore ?
					(this.getFunnelStore.currency_code || "USD") :
					(this.$store.state.userInfo.default_currency_code || "USD")
		}
	},
	methods: {
		onQuillEditorCreated(editor) {
			editor.root.addEventListener("blur", () => this.priceEditorFocused=false);
		},
		is(role){
			return is(role)
		},
		onEditorChange({quill, html, text}){
			this.newData.display_price = html;
		},
		async openVariants(){
			await this.updateInfo();
			this.manageVariantsOpen = true;
		},
		statusToggle(key){
			this.status[key] = !this.status[key];
			localStorage.setItem('product.'+key, this.status[key]);
		},
		automationSaved() {
			this.currentAutomation = false;
			this.automationPopupOpen = false;
			this.loadAutomations();
		},
		itemEntryDeleteClick(item) {
			this.currentAutomation = item;
			this.isdeleteAutomationOpen = true;
		},
		requiredField(optionOne, optionTwo = false) {
			var conditionOne = false, conditionTwo = false;
			if (optionTwo) {
				conditionTwo = this.newData[optionTwo]
			}
			conditionOne = this.newData[optionOne] ? this.newData[optionOne] > 0 : false;

			let result = (!conditionOne);
			return result
		},

		copyClipboard(event, text) {
			console.log({event, text});
		},
		selectNumber(event, field) {
			isNaN(event) ? event = 0 : '';
			this.newData[field] = parseFloat(event);
		},
		editNumber(event, field) {
			isNaN(event.target.value) ? event.target.value = 0 : '';
			this.newData[field] = parseFloat(event.target.value);
		},
		editInfo(event, field) {
			this.newData[field] = event.target.value
		},
		editAutomationItem(item) {
			this.updateInfo();
			this.currentAutomation = item;
			this.automationPopupOpen = true;
		},
		showAutomationPopup() {
			this.currentAutomation = {};
			this.updateInfo();
			this.automationPopupOpen = true;
		},
		closePopup() {
			if (this.inEditor) this.$emit('close');
			else {
				let {id, step} = this.$route.params;
				this.$router.push({path: `/wfunnel/${id}/steps/${step}`});
			}
		},

		deleteProduct(id) {
			this.$store.commit("showProductDeletePopup");
		},
		automationTitle(id) {
			let title = 'On Purchase';
			let triggerId = parseInt(id);
			let ar = ['Purchase','Refund','New subscription',
			        'Subscription canceled','Recurring payment','Recurring payment fails']

			if (triggerId<1 || triggerId > ar.length+1)
				return title

			return ar[triggerId-1]
		},
		//API
		async updateInfo() {
			try {
				this.variantsSaving = true;
				if (this.currentProduct.id) {
					//EXISTING PRODUCT
					let data = {
						product_id: this.currentProduct.id,
						funnel_id: this.currentProduct.funnel_id,
						step_id: this.currentProduct.step_id,
						user_id: parseInt(this.$store.state.user),
						variants: JSON.stringify({variants: this.newVariants})
					}
					await this.api.wsteps.patchVariants(this.currentProduct.id, data);
				}
			} catch (e) {

			} finally {
				this.variantsSaving = false;
			}
		},
		async deleteAutomationItem(id) {
			this.isdeleteAutomationOpen = false;
			this.newAutomations = this.newAutomations.filter((item) => item.id !== id)
		},
		async saveData() {
			var errors = document.querySelectorAll('.app_settings_popup .required');
			if (errors.length) {
				this.validationError = true;
				setTimeout(() => {
					this.validationError = false;
				}, 5000)
			} else {
				this.validationError = false;
				this.loading = true;
				this.newData.config = JSON.stringify(this.config);

				let newProduct = {};
				newProduct = await this.api.wsteps.patchProduct(this.funnelId, this.stepId, this.newData);
				this.$store.dispatch('EDIT_PRODUCT', newProduct);

				if (!this.ifError) {
					let data = {
						product_id: newProduct.id,
						step_id: newProduct.step_id,
						funnel_id: newProduct.funnel_id,
						user_id: parseInt(this.$store.state.user),
						variants: JSON.stringify({variants: this.newVariants})
					}

					let variantsData = await this.api.wsteps.patchVariants(newProduct.id, data);
					newProduct.product_variants = variantsData;

					this.loading = false;
					if (this.inEditor) this.$emit('done', newProduct);
					this.closePopup();
				}

				this.loading = false;
			}
		},
		async loadAutomations() {
			try {
				this.loadingAutomations = true;
				this.newAutomations = await this.api.wsteps.getAutomations(this.currentProduct.id);
			} catch (e) {
				this.newAutomations = [];
				this.$warn(e);
			} finally {
				this.loadingAutomations = false;
			}
		},
		async init() {
			try {
				this.status.highlightClosed = localStorage.getItem('product.highlightClosed')==="true";
				this.status.priceClosed = localStorage.getItem('product.priceClosed')==="true";
				this.status.variantsClosed = localStorage.getItem('product.variantsClosed')==="true";
				this.status.automationsClosed = localStorage.getItem('product.automationsClosed')==="true";

				this.$store.commit("showProductSettingsPopup");
				let id = this.funnelId, step=this.stepId, productId=this.productId;

				let productRes = await this.api.wsteps.getVariants(id, step, productId);
				this.currentProduct = productRes;

				if (productRes.product_variants && productRes.product_variants) {
					try {
						this.newVariants = await JSON.parse(productRes.product_variants.variants).variants;
					} catch {
						this.newVariants = [];
					}
				} else
					this.newVariants = [];

				await this.loadAutomations();

				var safeString = JSON.stringify(this.currentProduct);
				this.newData = JSON.parse(safeString);
				console.log(this.newData);
				if (this.newData.config && this.newData.config.length) {
					this.config = JSON.parse(this.newData.config) || {};
				} else {
					this.config = {};
				}
			} catch (e) {
				this.$warn(e);
			} finally {
				this.loading = false;
			}
		},
		async updateAutomations() {
			this.newAutomations = await this.api.wsteps.getAutomations(this.currentProduct.id);
		},
	},
	mounted() {
		this.init();
	},
	created() {
		this.recurringTimes = [{id: 0, text: 'Infinite'}];
		for (let i=2; i <= 52; i++) {
			this.recurringTimes.push({id: i, text: ''+i})
		}

		this.billingCycles = [];
		for (let i=1; i <= 30; i++) {
			this.billingCycles.push({id: i, text: i})
		}
	}
}
</script>
<style lang="scss">
.product-settings-popup-wrap {
	.display-price-editor {
		display: block;
		border: 1px solid $grey;
		border-radius: 3px;
		&.__focused {
			border: 1px solid $blue !important;
		}
		&:hover {
			border: 1px solid $dark-grey;
		}
		.ql-formats{
			display: flex;
		}
		.ql-toolbar.ql-snow {
			display: flex;
			flex-direction: row;
			border: none;
		}
		.ql-container.ql-snow {
			border: none !important;
			.ql-editor {
				border-radius: 0 0 5px 5px;
				border: none !important;
				border-top: 1px solid $light-grey !important;
				padding: 8px 10px !important;
				width: 100%;

				&:focus-visible {
				}
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.automation-items {
	gap: 10px;
	display: flex;
	flex-direction: column;
}
.billing-panel {
	display: flex;
	flex-direction: row;
	gap: 6px;

	.billing-box {
		flex: 1;
		&.__price {
		}
		&.__cycle {
			max-width: 110px;
		}
	}
}
.popup_side_content {
	padding: 0;
}

.popup_left_side {
	padding: 0;
}

.product-name {
	max-width: 600px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	display: flex;
	padding: 20px 50px 20px 20px;

	> span {
		display: block;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
}

.bottom_btns_wrpr {
	padding: 15px 20px;

	> .button:last-child {
		margin-right: 5px;
		position: absolute;
		right: 55px;
	}
}

.automation-item .img-wrap img {
	display: block;
	width: 40px;
}
</style>
